import axios from '../script/axiosAMS'

export default {
  getQuality (params, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/quality',
      method: 'get',
      params: params,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  quality (method, data, resultCallback) {
    axios.requestWith({
      url: '/api/quality',
      method: method,
      data: data,
      resultCallback: resultCallback
    })
  },
  bulkInsertQuality (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/quality',
      method: 'put',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  setStep (data, resultCallback) {
    axios.requestWith({
      url: '/api/quality/setStep',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  proc (data, resultCallback) {
    axios.requestWith({
      url: '/api/quality/proc',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  bulkUpdateProc (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/quality/proc',
      method: 'post',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/shadowQuality.js